import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import back from "../../Assets/groupcar.png";
import logo from "../../Assets/logo.png";

import { RegisterAPI } from "../../API/Auth"
import { ToastContainer, toast } from 'react-toastify';

import "./Signup.scss";

const Signup = () => {
  let navigate = useNavigate()


  const [enteredData, setEnteredData] = useState({
    name: "",
    zipCode: "",
    email: "",
    password: "",
    confirmPassword: ""
  })

  const enteringData = (event) => {
    let { name, value } = event.target
    setEnteredData((preVal) => {
      return {
        ...preVal,
        [name]: value
      }
    })
  }

  const registerUser = async () => {
    if (!enteredData.name || !enteredData.email || !enteredData.password || !enteredData.confirmPassword) {
      toast.warn('Fill all the Fields', {
        position: "top-right",
        autoClose: 300,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        });
    } else {
      if (enteredData.password != enteredData.confirmPassword) {
        toast("Confirm Password Doesn't match", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          });
      } else {
        let res = await RegisterAPI(enteredData)
        if (res.error != null) {
          toast.error(res.error, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            });
        } else {
          toast.success(res.data.message, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            });
          navigate("/login")
        }
      }
    }
  }

  return (
    <div className="main_Signup">
      <div className="back_img">
        <img src={back} />
      </div>
      <div className="transparent"></div>
      <div className="left_mail">
        <div className="mail_content">
          <img src={logo} />
          <div className="title">Sign Up</div>
          <input name="name" value={enteredData.name} onChange={enteringData} type="text" placeholder="Enter Your Name" />
          <input name="email" value={enteredData.email} onChange={enteringData} type="email" placeholder="Enter Your Email" />
          <input name="zipCode" value={enteredData.zipCode} onChange={enteringData} type="text" placeholder="Enter Your Zipcode" />
          <input name="password" value={enteredData.password} onChange={enteringData} type="Password" placeholder="Enter Your Password" />
          <input name="confirmPassword" value={enteredData.confirmPassword} onChange={enteringData} type="Password" placeholder="Confirm You Password" />
          <button onClick={registerUser}>Sign Up</button>
          <p>
            Already have an account?<span onClick={() => navigate("/login")}>Log In</span>
          </p>
        </div>
      </div>



    </div>
  );
};

export default Signup;
